import axios from 'axios';
import { createManagedSocket } from './realtime';

// export const API_URL = 'http://127.0.0.1:8000';
// export const WSS_URL = 'ws://127.0.0.1:8000';

// export const API_URL = 'https://api.testkasper.ru';
// export const WSS_URL = 'wss://api.testkasper.ru';

export const API_URL = 'https://api.alvi-clinic.ru';
export const WSS_URL = 'wss://api.alvi-clinic.ru';


// Добавим TELEGRAM_BOT_LINK в константы
export const TELEGRAM_BOT_LINK = 'https://t.me/alvi_doctors_bot';
export const TELEGRAM_PATIENT_BOT_LINK = 'https://t.me/alvi_clinic_bot';


// Проверка токена
export const APIVerifyToken = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/api/main/verify-token/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== ПАЦИЕНТЫ =====
export const APIGetPatients = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(`${API_URL}/api/main/patient-profiles/`, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIGetPatientDetail = async (token, patientId) => {
    try {
        const response = await axios.get(`${API_URL}/api/main/patient-profiles/${patientId}/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APICreatePatient = async (token, patientData) => {
    try {
        const formData = new FormData();
        formData.append('data', JSON.stringify(patientData));
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const response = await axios.post(`${API_URL}/api/main/patient-profiles/create/`, formData, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIGetDoctorPatients = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(`${API_URL}/api/main/doctor/patients/`, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Блокировка/разблокировка профиля
// reason — опциональная причина блокировки (поле блока на сервере)
export const APIToggleBlockProfile = async (token, profileId, type = 'patient', reason = '') => {
    try {
        const response = await axios.post(
            `${API_URL}/api/main/profiles/${profileId}/toggle-block/`,
            { profile_type: type, reason },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Удаление профиля
export const APIDeleteProfile = async (token, profileId, type = 'patient') => {
    try {
        const response = await axios.delete(
            `${API_URL}/api/main/profiles/${profileId}/delete/`,
            {
                ...getAuthConfig(token),
                data: { profile_type: type }
            }
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Полное удаление профиля из базы (необратимо)
export const APIPurgeProfile = async (token, profileId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/api/main/profiles/${profileId}/purge/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получение детальной информации о профиле
export const APIGetProfileDetail = async (profileId, token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/main/profiles/${profileId}/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Создание профиля
export const APICreateProfile = async (profileData, token) => {
    try {
        const formData = new FormData();
        formData.append('data', JSON.stringify(profileData));
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const response = await axios.post(
            `${API_URL}/api/main/profiles/`,
            formData,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Обновление профиля
export const APIUpdateProfile = async (profileId, profileData, token) => {
    try {
        const formData = new FormData();
        formData.append('data', JSON.stringify(profileData));
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const response = await axios.put(
            `${API_URL}/api/main/profiles/${profileId}/update/`,
            formData,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получение списка докторов
export const APIGetDoctors = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(`${API_URL}/api/main/doctor-profiles/`, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ======= Управление токенами подключения =====


export const APICreateConnectToken = async (token, data) => {
    try {
        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const response = await axios.post(`${API_URL}/api/main/connect-tokens/create/`, formData, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIGetConnectTokens = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(`${API_URL}/api/main/connect-tokens/`, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIDeactivateConnectToken = async (token, tokenId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/main/connect-tokens/${tokenId}/deactivate/`, 
            {},
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};



// ===== ЧАТЫ =====

// Создание чата с пользователем
export const APICreateChatWithUser = async (profileId, token) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/chats/create/`,
            { partner_profile_id: profileId },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Создать чат с пациентом
export const APICreateChatWithPatient = async (patientId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/chats/create-with-patient/`,
      { patient_id: patientId },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить чаты
export const APIGetChats = async (token, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `${API_URL}/api/chats/${queryString ? '?' + queryString : ''}`;
  try {
    const response = await axios.get(
      url,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить сообщения чата по ID с пагинацией
export const APIGetChatMessagesById = async (chatId, token, limit = 30, offset = 0, cursor = {}) => {
  const params = new URLSearchParams({ limit, offset, ...cursor });
  try {
    const response = await axios.get(`${API_URL}/api/chats/${chatId}/messages/?${params}`, getAuthConfig(token));
    return response.data;
  } catch (error) { handleApiError(error); throw error; }
};

// Отправка сообщения в чат
export const APISendMessage = async (chatId, formData, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/chats/${chatId}/send-message/`,
      formData,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// WebSocket подключение к потоку сообщений
export const createWebSocketConnection = (chatId, token, onMessageCallback, onStatusChange, options = {}) =>
  createManagedSocket(() => {
    const access = typeof token === 'function' ? token() : token;
    return `${WSS_URL}/chatws/${chatId}/?token=${encodeURIComponent(access || '')}`;
}, onMessageCallback, onStatusChange, options);


// Получить сотрудников без личных чатов
export const APIGetProfilesWithoutDM = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/chats/profiles-without-dm/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Создать пустой чат (групповой)
export const APICreateEmptyChat = async (chatData, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/chats/create-empty/`,
      chatData,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Добавить пользователя в чат
export const APIAddUserToChat = async (chatId, profileId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/chats/${chatId}/add-user/`,
      { profile_id: profileId },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Создать чат с сотрудником
export const APICreateChatWithProfile = async (profileId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/chats/create/`,
      { 
        partner_profile_id: profileId,
        profile_id: JSON.parse(localStorage.getItem('userData'))?.id // или из контекста
      },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Запрос сотрудников не в чате
export const APIGetProfilesNotInChat = async (chatId, token) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/chats/${chatId}/profiles-not-in-chat/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Получить количество непрочитанных сообщений
export const APIGetUnreadCounts = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/chats/unread-counts/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Отметить сообщения как прочитанные
export const APIMarkMessagesAsRead = async (chatId, messageIds, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/chats/${chatId}/mark-read/`,
      { message_ids: messageIds },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// WebSocket подключение для уведомлений
export const createNotificationWebSocketConnection = (token, onNotificationCallback, onStatusChange, options = {}) =>
  createManagedSocket(() => {
    const access = typeof token === 'function' ? token() : token;
    return `${WSS_URL}/notifications/?token=${encodeURIComponent(access || '')}`;
}, onNotificationCallback, onStatusChange, options);

// Присоединиться к чату
export const APIJoinChat = async (chatId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/chats/${chatId}/join/`,
      {},
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Покинуть чат
export const APILeaveChat = async (chatId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/chats/${chatId}/leave/`,
      {},
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== ОПАСНЫЕ ДИАЛОГИ =====

// Переключение статуса опасности чата
export const APIToggleChatDanger = async (chatId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/chats/${chatId}/toggle-danger/`,
      {},
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Пометка сообщения как опасного
export const APIMarkMessageAsDangerous = async (messageId, token, target) => {
  if (target !== null && typeof target !== 'boolean') {
    throw new Error('Не указано целевое состояние отметки');
  }
  try {
    const response = await axios.post(
      `${API_URL}/api/chats/messages/${messageId}/mark-dangerous/`,
      { is_dangerous: target },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение списка опасных чатов
export const APIGetDangerChats = async (token, params = {}) => {
  try {
    const config = {
      ...getAuthConfig(token),
      params: params
    };
    const response = await axios.get(`${API_URL}/api/chats/danger-chats/`, config);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== ТЕСТЫ И ОПРОСНИКИ =====

// Получение списка тестов (с фильтрацией по создателю)
export const APIGetTests = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        // Правильный эндпоинт из urls.py
        const response = await axios.get(`${API_URL}/api/material/tests/`, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получение деталей теста
export const APIGetTestDetail = async (token, testId) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/material/tests/${testId}/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Удаление теста
export const APIDeleteTest = async (token, testId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/api/material/tests/${testId}/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
}


// Создание теста
export const APICreateTest = async (token, testData) => {
    try {
        // const formData = new FormData();
        // formData.append('data', JSON.stringify(testData));
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const response = await axios.post(
            `${API_URL}/api/material/tests/`,
            testData,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Обновление теста
export const APIUpdateTest = async (token, testId, testData) => {
    try {
        // const formData = new FormData();
        // formData.append('data', JSON.stringify(testData));
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const response = await axios.put(
            `${API_URL}/api/material/tests/${testId}/`,
            testData,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Старт сессии тестирования
export const APIStartTestSession = async (token, testId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/material/sessions/start/`,
            { test_id: testId },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получить текущий вопрос
export const APIGetCurrentQuestion = async (token, sessionId) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/material/sessions/${sessionId}/current-question/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Отправить ответ
export const APISubmitTestAnswer = async (token, answerData) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/material/sessions/submit-answer/`,
            answerData,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Управление избранными тестами
export const APIToggleFavoriteTest = async (token, testId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/material/favorites/toggle/`,
            { test_id: testId },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Пропустить вопрос
export const APISkipQuestion = async (token, sessionId, questionId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/material/sessions/skip-question/`,
            { session_id: sessionId, question_id: questionId },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }

};

export const APICreateTestResult = async (token, resultData) => {
    try {
        const formData = new FormData();
        formData.append('data', JSON.stringify(resultData));
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const response = await axios.post(`${API_URL}/api/material/test-results/create/`, formData, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получение вопросов теста
export const APIGetTestQuestions = async (token, testId, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(
            `${API_URL}/api/material/tests/${testId}/questions/`,
            config
        );
        return response.data;
    } catch (error) {
        console.error('Ошибка при загрузке вопросов теста:', error);
        handleApiError(error);
        throw error;
    }
};


// ===== РЕЗУЛЬТАТЫ ТЕСТОВ =====

// Получить результаты тестов
export const APIGetTestResults = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(
            `${API_URL}/api/material/test-results/`,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получить детали результата
export const APIGetTestResultDetail = async (token, resultId) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/material/test-results/${resultId}/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Обновить результат (добавить заметки врача)
export const APIUpdateTestResult = async (token, resultId, resultData) => {
    try {
        const formData = new FormData();
        formData.append('data', JSON.stringify(resultData));
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const response = await axios.put(
            `${API_URL}/api/material/test-results/${resultId}/`,
            formData,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Скачать результат теста
export const APIDownloadTestResult = async (token, resultId, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params,
            responseType: 'blob'
        };
        const response = await axios.get(
            `${API_URL}/api/material/test-results/${resultId}/download/`,
            config
        );
        return response;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ===== КАТЕГОРИИ =====

// Получить категории тестов
export const APIGetTestCategories = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(
            `${API_URL}/api/material/test-categories/`,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Создать категорию
export const APICreateTestCategory = async (token, categoryData) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/material/test-categories/`,
            categoryData,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ===== ИЗБРАННЫЕ ТЕСТЫ =====

// Получить избранные тесты
export const APIGetFavoriteTests = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(
            `${API_URL}/api/material/favorite-tests/`,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Удалить из избранного
export const APIRemoveFavoriteTest = async (token, testId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/api/material/favorite-tests/${testId}/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== СТАТИСТИКА =====

// Получить статистику тестирования
export const APIGetTestStatistics = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/material/test-statistics/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получить активные сессии пользователя
export const APIGetMyActiveSessions = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/material/my-active-sessions/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ===== ОБУЧАЮЩИЕ МАТЕРИАЛЫ =====
export const APIGetEducationalMaterials = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(
            `${API_URL}/api/material/educational-materials/`,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIDownloadMaterial = async (token, materialId) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/material/educational-materials/${materialId}/download/`,
            {
                ...getAuthConfig(token),
                responseType: 'blob'
            }
        );
        return response;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== УПРАВЛЕНИЕ КЛЮЧЕВЫМИ СЛОВАМИ ОПАСНЫХ СООБЩЕНИЙ =====

// Получение списка ключевых слов
export const APIGetDangerKeywords = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(`${API_URL}/api/chats/danger-keywords/`, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Создание ключевого слова
export const APICreateDangerKeyword = async (token, keywordData) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/chats/danger-keywords/create/`,
            keywordData,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Обновление ключевого слова
export const APIUpdateDangerKeyword = async (token, keywordId, keywordData) => {
    try {
        const response = await axios.put(
            `${API_URL}/api/chats/danger-keywords/${keywordId}/update/`,
            keywordData,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Удаление ключевого слова
export const APIDeleteDangerKeyword = async (token, keywordId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/api/chats/danger-keywords/${keywordId}/delete/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Включение/выключение ключевого слова
export const APIToggleDangerKeywordActive = async (token, keywordId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/chats/danger-keywords/${keywordId}/toggle-active/`,
            {},
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== АВТОРИЗАЦИЯ =====
export const APIPatientLoginByTelegram = async (telegramId) => {
    try {
        const response = await axios.post(`${API_URL}/api/main/auth/patient/telegram/`, {
            telegram_id: telegramId
        });
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIPatientLoginByToken = async (activationToken) => {
    try {
        const response = await axios.post(`${API_URL}/api/main/auth/patient/token/`, {
            activation_token: activationToken
        });
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== ДАШБОРД И СТАТИСТИКА =====
export const APIGetDashboardStats = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/main/dashboard-stats/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== ЗАЯВКИ КЛИЕНТОВ =====

// Получение списка заявок
export const APIGetClientRequests = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(`${API_URL}/api/main/client-requests/`, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получение деталей заявки
export const APIGetClientRequestDetail = async (token, requestId) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/main/client-requests/${requestId}/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Обновление заявки
export const APIUpdateClientRequest = async (token, requestId, requestData) => {
    try {
        const formData = new FormData();
        formData.append('data', JSON.stringify(requestData));
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const response = await axios.put(
            `${API_URL}/api/main/client-requests/${requestId}/update/`,
            formData,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Удаление заявки
export const APIDeleteClientRequest = async (token, requestId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/api/main/client-requests/${requestId}/delete/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Конвертация заявки в профиль
export const APIConvertClientRequestToProfile = async (token, requestId, payload = {}) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/main/client-requests/${requestId}/convert-to-profile/`,
            payload,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIGetClientRequestMisCandidates = async (token, requestId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/main/client-requests/${requestId}/mis-candidates/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== НАЗНАЧЕНИЯ ТЕСТОВ =====

// Создание назначения теста
export const APIAssignTest = async (token, assignmentData) => {
    try {
        const formData = new FormData();
        formData.append('data', JSON.stringify(assignmentData));
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const response = await axios.post(
            `${API_URL}/api/material/assign-test/`,
            formData,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получение назначенных тестов
export const APIGetAssignedTests = async (token, params = {}) => {
    try {
        const config = {
            ...getAuthConfig(token),
            params: params
        };
        const response = await axios.get(
            `${API_URL}/api/material/assigned-tests/`,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Удаление назначенного теста
export const APIDeleteAssignedTest = async (token, sessionId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/api/material/assigned-tests/${sessionId}/delete/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получение статистики назначений
export const APIGetAssignmentsStatistics = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/material/assignments-statistics/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== СПЕЦИАЛИЗАЦИИ =====
export const APIGetSpecializations = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/main/specializations/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Контент кабинета пациента: запись / как нас найти / FAQ / контакт администратора
export const APIGetPatientInfo = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/main/patient/info/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// Обновление врача в заявке
export const APIUpdateClientRequestDoctor = async (token, requestId, doctorId) => {
    try {
        const formData = new FormData();
        formData.append('data', JSON.stringify({ doctor_id: doctorId }));
        const config = {
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
        };
        const response = await axios.put(
            `${API_URL}/api/main/client-requests/${requestId}/update/`, formData, config
        );
        return response.data;
    } catch (error) { handleApiError(error); throw error; }
};

// Получение связей пациент-врач
export const APIGetPatientDoctorRelations = async (token, patientId) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/main/profiles/${patientId}/relations/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) { handleApiError(error); throw error; }
};

// Создание связки пациент-врач
export const APICreatePatientDoctorRelation = async (token, patientId, doctorId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/main/profiles/${patientId}/relations/`,
            { doctor_id: doctorId },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) { handleApiError(error); throw error; }
};

// Удаление связки пациент-врач
export const APIDeletePatientDoctorRelation = async (token, patientId, relationId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/api/main/profiles/${patientId}/relations/${relationId}/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) { handleApiError(error); throw error; }
};



// =====================================================
// ===  ЧАТ: РЕДАКТИРОВАНИЕ / УДАЛЕНИЕ СООБЩЕНИЙ     ===
// =====================================================

// Редактирование сообщения (только автор в пределах окна редактирования
// или админ/модератор без ограничения по времени)
export const APIEditMessage = async (messageId, content, token) => {
    try {
        const response = await axios.put(
            `${API_URL}/api/chats/messages/${messageId}/edit/`,
            { content },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Soft-delete сообщения (ставит hide=true на сервере)
export const APIDeleteMessage = async (messageId, token) => {
    try {
        const response = await axios.delete(
            `${API_URL}/api/chats/messages/${messageId}/delete/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Статистика времени ответа врача по конкретному чату
export const APIGetChatResponseStats = async (chatId, token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/chats/${chatId}/response-stats/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// =====================================================
// ===  ВРАЧ: ССЫЛКА ПОДКЛЮЧЕНИЯ ПАЦИЕНТА (profile_token) ===
// =====================================================

// Получение deeplink-ссылки для подключения пациента к врачу.
// Возвращает: { profile_id, profile_token, connection_link }
export const APIGetProfileConnectionLink = async (profileId, token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/main/profiles/${profileId}/connection-link/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Пересоздание profile_token врача (старая ссылка перестанет работать)
export const APIRegenerateProfileToken = async (profileId, token) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/main/profiles/${profileId}/regenerate-profile-token-web/`,
            {},
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// =====================================================
// ===  ПРИЁМЫ ПАЦИЕНТОВ И ДЕДЛАЙН ОТВЕТА ВРАЧА      ===
// =====================================================

// Список приёмов. params: { overdue: 'true' } чтобы показать только просроченные
export const APIGetAppointments = async (token, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    try {
        const response = await axios.get(
            `${API_URL}/api/main/appointments/${queryString ? '?' + queryString : ''}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Создание приёма. data: { patient_id, doctor_id?, date_appointment, response_deadline_hours? }
export const APICreateAppointment = async (token, data) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/main/appointments/`,
            data,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Обновление приёма. data: { mark_responded?, response_deadline_hours?, date_appointment? }
export const APIUpdateAppointment = async (token, appointmentId, data) => {
    try {
        const response = await axios.put(
            `${API_URL}/api/main/appointments/${appointmentId}/update/`,
            data,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// =====================================================
// ===  ЗАБЛОКИРОВАННЫЕ ПРОФИЛИ (для админа/модератора) ===
// =====================================================

export const APIGetBlockedProfiles = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/main/profiles/blocked/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// =====================================================
// ===  СТАТИСТИКА ПО ЧАТАМ (отдельный эндпоинт)     ===
// =====================================================

// Возвращает: active_chats, messages_today, activity_trend,
// total_danger_messages, recent_danger_messages,
// avg_doctor_response_seconds, avg_message_length, my_unread_messages
export const APIGetChatStats = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/main/chat-stats/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// =====================================================
// ===  КЛИЕНТСКИЕ НАСТРОЙКИ ЧАТА                    ===
// =====================================================

// Возвращает: patient_message_max_length, message_edit_window_minutes,
// chat_max_file_size_mb, doctor_response_deadline_hours.
// Грузится один раз на старте приложения, кэшируется в контексте.
export const APIGetChatSettings = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/main/chat-settings/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== ЗАПИСЬ / БРОНЬ (МИС) =====
export const APIBookingMy = async (token, params = {}) => {
    try {
        const config = { ...getAuthConfig(token), params };
        const response = await axios.get(`${API_URL}/api/main/booking/my/`, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIBookingSlots = async (token, params = {}) => {
    try {
        const config = { ...getAuthConfig(token), params };
        const response = await axios.get(`${API_URL}/api/main/booking/slots/`, config);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIBookingCreate = async (token, data) => {
    try {
        const response = await axios.post(`${API_URL}/api/main/booking/create/`, data, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIBookingCancel = async (token, bookingId, reason = '') => {
    try {
        const response = await axios.post(`${API_URL}/api/main/booking/${bookingId}/cancel/`, { reason }, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIBookingServices = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/api/main/booking/services/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

export const APIBookingClinics = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/api/main/booking/clinics/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Конфиг виджета онлайн-записи МИС: { success, enabled, url }. GET /api/main/mis/widget-config/
export const APIGetMisWidgetConfig = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/api/main/mis/widget-config/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ===== ОЦЕНКИ ПРИЁМОВ (ОТЗЫВЫ) =====
// Врачи, к которым подключён пациент (для выбора в оценке/записи)
export const APIReviewMyDoctors = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/api/main/patient/my-doctors/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Создать оценку. data: { doctor_id, rating, comment }
export const APIReviewCreate = async (token, data) => {
    try {
        const response = await axios.post(`${API_URL}/api/main/reviews/create/`, data, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Мои оценки (опционально, для истории)
export const APIReviewMy = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/api/main/reviews/my/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ===== МИС: импорт врачей (админ) =====
export const APIImportDoctorsFromMIS = async (token) => {
    try {
        const response = await axios.post(`${API_URL}/api/main/mis/import-doctors/`, {}, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== PUSH-УВЕДОМЛЕНИЯ =====
// POST /api/main/push/subscribe/
export const APIRegisterPushSubscription = async (token, subscriptionData) => {
    try {
        const r = await axios.post(`${API_URL}/api/main/push/subscribe/`, subscriptionData, getAuthConfig(token));
        return r.data;
    } catch (e) { handleApiError(e); throw e; }
};

// POST /api/main/push/unsubscribe/
export const APIUnregisterPushSubscription = async (token, endpoint) => {
    try {
        const r = await axios.post(`${API_URL}/api/main/push/unsubscribe/`, { endpoint }, getAuthConfig(token));
        return r.data;
    } catch (e) { handleApiError(e); throw e; }
};

// GET /api/main/push/subscriptions/
export const APIGetPushSubscriptions = async (token) => {
    try {
        const r = await axios.get(`${API_URL}/api/main/push/subscriptions/`, getAuthConfig(token));
        return r.data;
    } catch (e) { handleApiError(e); throw e; }
};

// POST /api/main/push/test/
export const APITestPushNotification = async (token) => {
    try {
        const r = await axios.post(`${API_URL}/api/main/push/test/`, {}, getAuthConfig(token));
        return r.data;
    } catch (e) { handleApiError(e); throw e; }
};

// POST /api/main/me/notifications/toggle/
export const APIToggleNotifications = async (token, enabled) => {
    try {
        const r = await axios.post(`${API_URL}/api/main/me/notifications/toggle/`, { enabled }, getAuthConfig(token));
        return r.data;
    } catch (e) { handleApiError(e); throw e; }
};

// GET /api/main/me/notifications/silent-kinds/
export const APIGetSilentKinds = async (token) => {
    try {
        const r = await axios.get(`${API_URL}/api/main/me/notifications/silent-kinds/`, getAuthConfig(token));
        return r.data;
    } catch (e) { handleApiError(e); throw e; }
};

// POST /api/main/me/notifications/silent-kinds/set/
export const APISetSilentKinds = async (token, kinds) => {
    try {
        const r = await axios.post(`${API_URL}/api/main/me/notifications/silent-kinds/set/`, { kinds }, getAuthConfig(token));
        return r.data;
    } catch (e) { handleApiError(e); throw e; }
};

// GET /api/main/push/check-token/?device_token=<token>
export const APICheckPushByToken = async (token, deviceToken) => {
    try {
        const r = await axios.get(`${API_URL}/api/main/push/check-token/`, {
            ...getAuthConfig(token),
            params: { device_token: deviceToken },
        });
        return r.data;
    } catch (e) { handleApiError(e); throw e; }
};


export const APIDutyStart = async (token) => {
  const resp = await axios.post(
    `${API_URL}/api/chats/duty/start/`,
    {},
    getAuthConfig(token),
  );
  return resp.data;
};

export const APIAssignDoctor = async (patientId, doctorId, token) => {
  const resp = await axios.post(
    `${API_URL}/api/main/patient/${patientId}/assign-doctor/`,
    { doctor_id: doctorId },
    getAuthConfig(token),
  );
  return resp.data;
};


// Заявка пациента на подключение к врачу (создаётся заявка, не связка)
export const APICreateConnectionRequest = async (doctorId, token) => {
  const resp = await axios.post(
    `${API_URL}/api/main/patient/connection-request/`,
    { doctor_id: doctorId }, getAuthConfig(token),
  );
  return resp.data;
};

// Подключение авторизованного пациента к врачу по токену из ссылки
export const APIConnectByToken = async (doctorToken, token) => {
  const resp = await axios.post(
    `${API_URL}/api/main/patient/connect-by-token/`,
    { doctor_token: doctorToken }, getAuthConfig(token),
  );
  return resp.data;
};

// Админ: список запросов на подключение пациента
export const APIGetConnectionRequests = async (token, profileId) => {
  const resp = await axios.get(
    `${API_URL}/api/main/patient/${profileId}/connection-requests/`, getAuthConfig(token),
  );
  return resp.data;
};

export const APIApproveConnectionRequest = async (token, requestId) => {
  const resp = await axios.post(
    `${API_URL}/api/main/connection-request/${requestId}/approve/`, {}, getAuthConfig(token),
  );
  return resp.data;
};

export const APIRejectConnectionRequest = async (token, requestId) => {
  const resp = await axios.post(
    `${API_URL}/api/main/connection-request/${requestId}/reject/`, {}, getAuthConfig(token),
  );
  return resp.data;
};

export const APIGetChatSchedule = async (chatId, token) => {
  const response = await axios.get(`${API_URL}/api/chats/${chatId}/schedule/`, getAuthConfig(token));
  return response.data;
};
export const APIGetWorkCalendars = async (token) => {
  const response = await axios.get(`${API_URL}/api/main/work-calendars/`, getAuthConfig(token));
  return response.data;
};
export const APISaveWorkCalendar = async (token, data) => {
  const response = await axios.post(`${API_URL}/api/main/work-calendars/`, data, getAuthConfig(token));
  return response.data;
};

// Добавьте эти две функции в конец файла после APISaveWorkCalendar.
export const APIGetDoctorCalendar = async (profileId, token) => {
  const response = await axios.get(`${API_URL}/api/main/profiles/${profileId}/calendar/`, getAuthConfig(token));
  return response.data;
};
export const APISaveDoctorCalendar = async (profileId, token, data) => {
  const response = await axios.put(`${API_URL}/api/main/profiles/${profileId}/calendar/`, data, getAuthConfig(token));
  return response.data;
};


// ===== Вспомогательные функции =====

// Обработка ошибок API
const handleApiError = (error) => {
  if (error.code === 'ECONNABORTED') {
    console.error('Запрос превысил лимит ожидания.');
  } else if (error.code === 'ERR_NETWORK') {
    console.error('Ошибка сети.');
  } else if (error.response) {
    // Ошибка с ответом от сервера
    console.error('Ошибка сервера:', error.response.status, error.response.data);
  } else {
    console.error('Произошла ошибка:', error.message);
  }
};

// Создание конфигурации axios с токеном авторизации
export const getAuthConfig = (token) => ({
  headers: {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
});